import { useFormikContext } from "formik";
import { motion } from "framer-motion";
import { FC, useCallback } from "react";

import __ from "web/Layout/Translations";

import ArrowUpIcon from "web/assets/icons/arrow-up.svg";

import useDropdown from "web/hooks/useDropdown";

import Dropdown from "./Dropdown";
import { DISTANCE_DROPDOWN_ID } from "./const";
import classes from "./distance.scss";

interface IDistanceProps {
  name: string;
  options: {
    value: string;
    label: string;
  }[];
}

const dropdownVariants = {
  open: {
    height: "auto",
  },
  closed: {
    height: 0,
  },
};
const transition = { duration: 0.25 };

const Distance: FC<IDistanceProps> = ({ name, options }) => {
  const { values, setFieldValue } = useFormikContext<Record<string, string>>();
  const [isOpen, setIsOpen] = useDropdown({
    scopeSelector: `.${classes.root}`,
  });
  const valueCurrent = values && values[name];
  const optionCurrent = valueCurrent
    ? options.find((optionItem) => optionItem.value === valueCurrent)
    : null;
  const labelCurrent = optionCurrent ? optionCurrent.label : null;
  const classNameWrapper = isOpen ? classes.wrapperActive : classes.wrapper;
  const changeHandler = useCallback(
    (valueChosen: string) => {
      setFieldValue(name, valueChosen);
      setIsOpen((status) => !status);
    },
    [setIsOpen, setFieldValue, name]
  );

  return (
    <div className={classes.root}>
      <div className={classNameWrapper}>
        <button
          type="button"
          className={classes.trigger}
          onClick={() => setIsOpen((state) => !state)}
          data-t1="distance_trigger_button"
          aria-label={`${__("Otwórz listę odległości")}. ${__(
            "Obecnie wybrana opcja"
          )}: ${labelCurrent}`}
          aria-expanded={isOpen}
          aria-haspopup="listbox"
          aria-controls={DISTANCE_DROPDOWN_ID}
        >
          {labelCurrent} <ArrowUpIcon width={10} className={classes.arrow} />
        </button>
        <div className={classes.body} data-t1="distance_trigger_dropdown">
          <motion.div
            className={classes.dropdown}
            animate={isOpen ? "open" : "closed"}
            transition={transition}
            variants={dropdownVariants}
          >
            <Dropdown
              options={options}
              onChange={changeHandler}
              value={valueCurrent}
            />
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Distance;
